const trimTrailingSlashes = (value = '') => value.replace(/\/+$/, '');

const legacyApiHost = (process.env.REACT_APP_API_BASE_HOST || '').trim();
const explicitApiBaseUrl = trimTrailingSlashes(process.env.REACT_APP_API_BASE_URL || '');

const apiBaseUrl = explicitApiBaseUrl || (legacyApiHost ? `https://${legacyApiHost}` : '');
const adminBaseUrl = trimTrailingSlashes(process.env.REACT_APP_ADMIN_BASE_URL || '');
const cookieSecure = `${process.env.REACT_APP_COOKIE_SECURE ?? 'true'}`.toLowerCase() === 'true';

const parseUrl = (value) => {
  if (!value) {
    return null;
  }

  try {
    return new URL(value);
  } catch (error) {
    return null;
  }
};

const apiUrl = parseUrl(apiBaseUrl);
const apiHostname = apiUrl?.hostname || '';
const apiCookieDomain = (process.env.REACT_APP_COOKIE_DOMAIN || '').trim()
  || (
    apiHostname && !['localhost', '127.0.0.1'].includes(apiHostname)
      ? apiHostname.replace(/^(api|api-next)\./, '')
      : ''
  );

export {
  adminBaseUrl,
  apiBaseUrl,
  apiCookieDomain,
  cookieSecure,
};
